import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Select } from '../../components/ui/Input';
import OrdemCompraForm from './OrdemCompraForm';
import OrdemCompraDetail from './OrdemCompraDetail';
import NotaEntradaDetail from './NotaEntradaDetail';
import { ordensCompraApi } from '../../api/compras';
import { COLORS } from '../../theme';

const STATUS_TOM = { aberta: 'info', parcial: 'aviso', atendida: 'sucesso', cancelada: 'perigo' };
const STATUS_LABEL = { aberta: 'Aberta', parcial: 'Parcialmente Recebida', atendida: 'Atendida', cancelada: 'Cancelada' };
const OPCOES_STATUS = [
  { value: '', label: 'Todos os status' },
  { value: 'aberta', label: 'Aberta' },
  { value: 'parcial', label: 'Parcialmente Recebida' },
  { value: 'atendida', label: 'Atendida' },
  { value: 'cancelada', label: 'Cancelada' }
];

export default function OrdensCompraList() {
  const [ordens, setOrdens] = useState([]);
  const [status, setStatus] = useState('');
  const [registroAberto, setRegistroAberto] = useState(undefined);
  const [notaAberta, setNotaAberta] = useState(null);

  const carregar = useCallback(() => {
    ordensCompraApi.listar(status ? { status } : {}).then(setOrdens).catch(() => {});
  }, [status]);

  useEffect(() => { carregar(); }, [carregar]);

  if (notaAberta) {
    return <NotaEntradaDetail notaEntradaId={notaAberta} onVoltar={() => { setNotaAberta(null); carregar(); }} />;
  }

  if (registroAberto === null) {
    return <OrdemCompraForm onVoltar={() => setRegistroAberto(undefined)} onSalvo={carregar} />;
  }

  if (registroAberto !== undefined) {
    return (
      <OrdemCompraDetail
        ordemCompraId={registroAberto}
        onVoltar={() => { setRegistroAberto(undefined); carregar(); }}
        onAbrirNota={setNotaAberta}
      />
    );
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <Select options={OPCOES_STATUS} value={status} onChange={e => setStatus(e.target.value)} style={{ width: 260 }} />
          <Btn onClick={() => setRegistroAberto(null)}>+ Nova Ordem de Compra</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Número</th>
              <th style={{ padding: 10 }}>Fornecedor</th>
              <th style={{ padding: 10 }}>Data</th>
              <th style={{ padding: 10 }}>Notas Anexadas</th>
              <th style={{ padding: 10 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {ordens.map(oc => (
              <tr key={oc.id} onClick={() => setRegistroAberto(oc.id)}
                style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                <td style={{ padding: 10 }}>#{oc.numero}</td>
                <td style={{ padding: 10 }}>{oc.fornecedor_nome}</td>
                <td style={{ padding: 10 }}>{new Date(oc.criado_em).toLocaleDateString('pt-BR')}</td>
                <td style={{ padding: 10 }}>
                  {oc.total_notas > 0 ? <Badge tom="sucesso">{oc.total_notas} nota(s)</Badge> : <Badge tom="neutro">Sem anexo</Badge>}
                </td>
                <td style={{ padding: 10 }}><Badge tom={STATUS_TOM[oc.status]}>{STATUS_LABEL[oc.status]}</Badge></td>
              </tr>
            ))}
            {ordens.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma ordem de compra ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
